export enum OWNER_TYPE {
  CUSTOMER = "customer",
  USER = "user",
}
